import { Select } from 'antd';
import styled from 'styled-components';

const StatusSelect = styled(Select)``;

const StatusOption = styled(Select.Option)``;

const Subtitle = styled.h4`
  margin-left: 10px;
`;

export { StatusSelect, StatusOption, Subtitle };
